export const copyToClipboard = async (text: string, options: { html?: string; preserveFormatting?: boolean } = {}) => {
  const { html = null, preserveFormatting = false } = options;

  try {
    if (navigator.clipboard && navigator.clipboard.write) {
      const clipboardItems: Record<string, Blob> = {};

      // include plain text
      clipboardItems['text/plain'] = new Blob([text], { type: 'text/plain' });

      // Include HTML if provided or if preserveFormatting is true
      if (html) {
        clipboardItems['text/html'] = new Blob([html], { type: 'text/html' });
      } else if (preserveFormatting) {
        // Auto-convert plain text to HTML with formatting preserved
        const htmlText = text
          .replace(/\n/g, '<br>')
          .replace(/ {2}/g, '&nbsp;&nbsp;')
          .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
        clipboardItems['text/html'] = new Blob([`<pre>${htmlText}</pre>`], { type: 'text/html' });
      }

      await navigator.clipboard.write([new ClipboardItem(clipboardItems)]);
      return true;
    }

    // Fallback to legacy method for plain text only
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // deprecated but still works
    const dummy = document.createElement('input');
    document.body.appendChild(dummy);
    dummy.setAttribute('value', text);
    dummy.select();
    const success = document.execCommand('copy');
    document.body.removeChild(dummy);
    return success;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to copy to clipboard:', err);
    return false;
  }
};
